<template>
  <div class="container exam">
    <div class="exam-wrapper">
      <div class="exam-list" v-for="activity in activityList" :key="activity.id" @click="$router.push({path: '/activity/view', query:{id:activity.id}})">
        <div class="exam-list-title">
          <p class="van-multi-ellipsis--l3">{{activity.title}}</p>
        </div>
        <div class="exam-list-btn">
          <van-button class="btn" color="#DB2D2D">查看活动</van-button>
        </div>
        <van-tag v-if="activityEnd(activity.endtime)">已结束</van-tag>
      </div>
    </div>
    <div class="IndexnoData" v-if="finished && activityList.length === 0">
      <img src="../../assets/images/activity.png" alt="">
      <p>暂时还没有新的活动哦~~</p>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'questionnaireIndex',
    data () {
      return {
        finished: false,
        activityList: []
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true,
        tipsMore: true
      })
      this.$fetch.get(API.ACLIST).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '活动获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.activityList = response.data.activityList
        this.finished = true
        load.clear()
      }).catch(error => {
        console.log(error)
        load.clear()
      })
      if (u.indexOf('MicroMessenger') > -1) {
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: window.location.href
        }).then(res => {
          let data = res.data
          wx.config({
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function(){
            wx.updateAppMessageShareData({
              title: '广东科技报-粤科网',
              desc: '传播最新科技资讯、普及科学知识。',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              }
            })
            wx.updateTimelineShareData({
              title: '广东科技报-粤科网',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              }
            })
            wx.onMenuShareWeibo({
              title: '广东科技报-粤科网',
              desc: '传播最新科技资讯、普及科学知识。',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              },
              cancel: function(){
                console.log('分享取消')
              }
            })
          })
        })
      }
    },
    methods: {
      activityEnd (endtime) {
        if (endtime.length > 0) {
          var end = new Date(endtime.replace(/-/g,'/')).getTime()
          var now = new Date().getTime()

          if (end > now) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    }
  }
</script>

<style lang="stylus">
</style>